import React from 'react';
import styles from './Index.module.css';
import { useTranslation } from 'react-i18next';

interface InfoCardProps {
  title: string;
  value: string | number;
  color?: string;
  border?: string;
}

const InfoCard: React.FC<InfoCardProps> = ({ title, value, color, border }) => (
  <div className={styles.card}>
    <h2 className={styles.cardTitle}>{title}</h2>
    <span className={styles.cardValue} style={{ color, border }}>
      {value}
    </span>
  </div>
);

interface DashboardHeaderProps {
  totalCount: number;
  cumulativeOK: number[];
  cumulativeNOk: number[];
  averageAccuracy: number;
}


const DashboardHeader: React.FC<DashboardHeaderProps> = ({ totalCount, cumulativeOK, cumulativeNOk, averageAccuracy }) => {
  const { t: translate } = useTranslation("dashboard");

  const lastOK = cumulativeOK[cumulativeOK.length - 1] || 0;
  const lastNOK = cumulativeNOk[cumulativeNOk.length - 1] || 0;
  const roundedAccuracy = Math.round((averageAccuracy + Number.EPSILON) * 100) / 100;
  

  // Definir a cor com base na média de acurácia
  let accuracyColor;
  if (roundedAccuracy < 60) {
    accuracyColor = "#F8243D"; // Baixa
  } else if (roundedAccuracy >= 60 && roundedAccuracy < 80) {
    accuracyColor = "#EC7304"; // Média
  } else {
    accuracyColor = "#00B13F"; // Alta
  }

  return (
    <div className={styles.dashboardHeader}>
      <InfoCard title={translate("TotalEvents")} value={totalCount} />
      <InfoCard title={translate("EventsOK")} value={lastOK} color="#44A959" />
      <InfoCard title={translate("EventsNOK")} value={lastNOK} color="#BD2B6A" />
      <InfoCard title={translate("AverageAccuracy")} value={roundedAccuracy + "%"} color={accuracyColor} />
    </div>
  );
};

export default DashboardHeader;
